import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

import { callAPI } from "../feature/APISlice";
import { openForm } from "../feature/formSlice";
import AdminNavbar from "./AdminNavbar";
import TeamMemberForm from "../Form/TeamMemberForm.js";

const BASE_URL = `${process.env.REACT_APP_PRODUCTION_API_URL}backend/api/admin/team-members`;

export default function TeamMemberList() {
  const dispatch = useDispatch();
  const { items, loading, error } = useSelector((s) => s.api);

  useEffect(() => {
    dispatch(callAPI({ method: "get", url: BASE_URL }));
  }, [dispatch]);

  return (
    <div>
      <AdminNavbar />

      <div className="customcontainer">
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "1rem",
          }}
        >
          <button
            className="admin-btn outline"
            onClick={() => dispatch(openForm(null))}
          >
            + Add Team Member
          </button>
        </div>

        {loading && <p>Loading...</p>}
        {error && <p className="error-text">{error}</p>}

        <div className="admin-card-grid">
          {items.length > 0 ? (
            items.map((m) => (
              <div className="admin-card" key={m.id}>
                <div className="admin-card-header">
                  <h4 className="admin-card-title">
                    {m.name || "No Name"}
                  </h4>
                </div>

                <p>{m.designation}</p>

                <p className="admin-card-status">
                  Status: {m.is_active ? " Active" : "❌ Inactive"}
                </p>

                <div className="admin-card-info">
                  <p>
                    Created By:{" "}
                    <strong>{m.createdByName || "Unknown"}</strong>
                  </p>
                  <p>
                    Updated By:{" "}
                    <strong>
                      {m.lastModifiedByName || "Unknown"}
                    </strong>
                  </p>
                </div>

                <div className="admin-card-actions">
                  <button
                    className="admin-card-btn"
                    onClick={() => dispatch(openForm(m.id))}
                  >
                    ✏️
                  </button>
                  <button
                    className="admin-card-btn"
                    onClick={() =>
                      window.confirm("Delete this team member?") &&
                      dispatch(
                        callAPI({
                          method: "delete",
                          url: `${BASE_URL}/${m.id}`,
                          data: { id: m.id },
                        })
                      )
                    }
                  >
                    🗑️
                  </button>
                </div>
              </div>
            ))
          ) : (
            !loading && <p>No team members found.</p>
          )}
        </div>
      </div>

      <TeamMemberForm />
    </div>
  );
}
